export type BrowserSession = {
  readonly expires: string;
  readonly user: {
    readonly id: string;
    readonly name?: string | null;
    readonly email?: string | null;
    readonly image?: string | null;
  };
};
export type SessionState =
  | {
      readonly kind: "pending";
      readonly session: null;
      readonly error: null;
    }
  | {
      readonly kind: "authenticated";
      readonly session: BrowserSession;
      readonly error: null;
    }
  | {
      readonly kind: "anonymous";
      readonly session: null;
      readonly error: null;
    }
  | {
      readonly kind: "unavailable";
      readonly session: BrowserSession | null;
      readonly error: Error;
    };
export type BrowserSessionContextValue = SessionState & {
  readonly refresh: () => Promise<void>;
};

export function initialSessionState(
  session: BrowserSession | null | undefined,
): SessionState {
  if (session === undefined)
    return { kind: "pending", session: null, error: null };

  if (session === null)
    return { kind: "anonymous", session: null, error: null };

  return { kind: "authenticated", session, error: null };
}

export function sessionChangeTrigger(
  event: Event,
  ownSource: string,
): Readonly<{ readonly trigger: unknown }> | null {
  if (event instanceof CustomEvent) return { trigger: event.detail };

  if (!(event instanceof MessageEvent)) return { trigger: undefined };

  const message: unknown = event.data;

  if (
    typeof message !== "object" ||
    message === null ||
    !("event" in message) ||
    message.event !== "session" ||
    ("source" in message && message.source === ownSource)
  )
    return null;

  const data = "data" in message ? message.data : undefined;
  return {
    trigger:
      typeof data === "object" && data !== null && "trigger" in data
        ? data.trigger
        : undefined,
  };
}
